import { render, staticRenderFns } from "./FileRenameDialog.vue?vue&type=template&id=48cbd591&scoped=true&lang=html"
import script from "./FileRenameDialog.vue?vue&type=script&lang=js"
export * from "./FileRenameDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cbd591",
  null
  
)

export default component.exports